import { Typography } from 'antd';

import { useProductLeftover } from '@app/pages/Warehouses/components/ProductLeftover/hooks/useProductLeftover';
import type { ProductLeftoverData } from '@app/pages/Warehouses/components/ProductLeftover/types';

import type { FC } from 'react';

interface ProductLeftoverProps extends ProductLeftoverData {}

export const ProductLeftover: FC<ProductLeftoverProps> = (props) => {
  const { text, type, physicalText } = useProductLeftover(props);

  return (
    <div className="ProductLeftover">
      <Typography.Text type={type}>{text}</Typography.Text>
      {physicalText && (
        <div>
          <Typography.Text>{physicalText}</Typography.Text>
        </div>
      )}
    </div>
  );
};
